import * as React from "react";
const SvgRequirement20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 20,
        fill: "black",
        viewBox: "0 0 16 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M5.5 3.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75ZM3.8 4.5H2v13h12v-13h-1.8A2.75 2.75 0 0 1 9.75 6h-3.5A2.75 2.75 0 0 1 3.8 4.5Zm8.597-2A2.751 2.751 0 0 0 9.75.5h-3.5a2.75 2.75 0 0 0-2.646 2H0v17h16v-17h-3.604ZM12 8.5H4v2h8v-2Zm-8 4h8v2H4v-2Z",
      clipRule: "evenodd"
    })
  );
export default SvgRequirement20Px;
